/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(updateCartCount, 500);
  document.querySelectorAll(".product__submit__add").forEach(button => {
    button.addEventListener("click", function () {
      setTimeout(updateCartCount, 500); // Delay to ensure cart updates before fetching count
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function () {
      setTimeout(updateCartCount, 1500);
  });
});

function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      let itemCount = data.item_count; // Get total item count
      console.log("Cart Count:", itemCount);

      // Update all elements with the class "cart-count"
      document.querySelectorAll('.cart-count').forEach(element => {
        element.textContent = itemCount;
      });
    })
    .catch(error => console.error('Error fetching cart:', error));

  function removeProductByType(type) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          let itemsToRemove = [];
          cart.items.forEach((item) => {
            if (item.product_type === type) {
              itemsToRemove.push(item.id);
            }
          });

          if (itemsToRemove.length > 0) {
            itemsToRemove.forEach(itemId => {
              const removeButton = document.getElementById(`${itemId}`);
              if (removeButton) {
                removeButton.click();
              }
            });
          }
        })
        .catch(error => console.error('Error fetching cart:', error));
    }

    function checkAndRemoveItems() {
      removeProductByType('DISPOSE');
      removeProductByType('RECYCLING_FEE');
    }

    checkAndRemoveItems();
    
    const refreshInterval = setInterval(() => {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const hasItemsToRemove = cart.items.some(item => 
            item.product_type === 'DISPOSE' || item.product_type === 'RECYCLING_FEE'
          );
          
          if (!hasItemsToRemove) {
            clearInterval(refreshInterval);
          } else {
            checkAndRemoveItems();
          }
        })
        .catch(error => console.error('Error fetching cart:', error));
    }, 1000);
}
